/** @format */
import { css } from 'styled-components';

import { theme } from '@toucan/client/global/theme';

export const miniProductCardStyles = css`
    z-index: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    width: min-content;
    height: 100%;

    .mini-product-card-thumbnail {
        margin-bottom: var(--layout-spacing-4);
    }

    .mini-product-card-condition {
        ${theme.typography.body_small}

        .condition-wrapper {
            display: block;
            color: var(--colors-text-secondary);
        }
    }

    .mini-product-card-price {
        ${theme.typography.body_normal_highlight}
        margin-bottom: auto;
    }
`;

export const cardBackgroundStyles = css`
    padding: var(--layout-spacing-8);
    height: 100%;
`;
